const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

const isValidField = (fieldName, fieldValue) => {
    switch (fieldName) {
        case ('email'):
            if (validateEmail(fieldValue)) {
                return true;
            } else {
                return false;
            }
        case ('phone-number'):
            // if (fieldValue.length === 10 && fieldValue.substr(0, 2) === '05') { // israel mobile
            if (fieldValue.length > 2) {
                return true;
            } else {                
                return false;
            }
        case ('bqst-card-number'):
            console.log('try to validate it', fieldValue);
            console.log('try to validate its length: ', fieldValue.length);
            if (fieldValue.length === 19 || fieldValue.length === 18) {
                return true;
            } else {
                return false;
            }
        case ('bqst-expiry'):            
            console.log('try to validate its length: ', fieldValue.length);
            // if (fieldValue.length === 10 && fieldValue.substr(0, 2) === '05') { // israel mobile
            if (fieldValue.length === 5) {
                return true;
            } else {
                return false;
            }
        case ('bqst-cvc'):
            // if (fieldValue.length === 10 && fieldValue.substr(0, 2) === '05') { // israel mobile
            if (fieldValue.length === 3 || fieldValue.length === 4) {
                return true;
            } else {
                return false;
            }
        case ('cell'):
            if (fieldValue.length > 2) {
                return true;
            } else {
                return false;
            }
        case ('goal'):
            if (fieldValue > 0) {
                return true;
            } else {
                return false;
            }
        case ('donation-amount'):
            if (fieldValue > 0) {
                return true;
            } else {
                return false;
            }
        case ('terms-checkbox'):
            console.log('try to validate checkbox', document.getElementById('terms-checkbox').checked);
            return document.getElementById('terms-checkbox').checked;
        default: // text field
            if (fieldValue.length === undefined || fieldValue.length === 0) {
                return false;
            } else {
                return true;
            }
    }
};

const highLightField = (fieldId, resultValue) => {
    const inputEl = document.getElementById(fieldId) ? document.getElementById(fieldId) : '';
    if (!resultValue) {
        if (!inputEl.parentElement.className.includes('not-valid')) {
            inputEl.parentElement.className += ' not-valid';
        }
    } else {
        inputEl.parentElement.className = inputEl.parentElement.className.replace('not-valid', '');
    }
};

export const validateForm = (fields, image = null, iDPhoto = null) => {
    let result = true;
    let notice = '';
    fields.forEach((field) => {
        if (field === 'image') { // image case
            if (image == null) {
                result = false;
                notice = 'Please upload your photo!';
            } else {
                result = true;
            }
        } else if (field === 'id-photo') { // image case
                if (iDPhoto === null) {
                    result = false;
                    notice = 'Please upload your ID photo!';
                    highLightField(field, false);
                } else {
                    result = true;
                    highLightField(field, true);
                }
        } else { // other then image cases
            const inputEl = document.getElementById(field) ? document.getElementById(field) : '';
            if (!isValidField(field, inputEl.value)) { // do validate input
                result = false;
                if (notice !== 'Please upload your photo!') { // let image notice to be one and only
                    notice = 'Please fill in all mandatory fields!';
                }
                // take care to add unique not valid class to parent el
                highLightField(field, false);
            } else { // take care to remove not valid class                
                highLightField(field, true);
            }
        }
    });
    const returnResult = { result, notice };
    console.log('returnResult', returnResult);
    return returnResult;
};
